export default __webpack_public_path__ + "static/media/3.6e8a0b80.png";